import { IconButton } from "@carbon6/c6-frontend-design";
import type { Mapping, MappingIssue } from "../../../domain/mapping";
import { issueTarget } from "../../../feature/issuePath";
import { mappingIssueDetails, mappingIssueText } from "../../../feature/mappingIssueMessage";
import { describeMappingPath } from "../../../feature/mappingPath";
import styles from "./MappingForm.module.css";

type IssueListProps = {
  /** 목록의 접근성 이름. 예) `위치 검증 결과`. */
  label: string;
  issues: readonly MappingIssue[];
  /** 경로 이름을 풀 매핑 — 검증에 보낸 매핑이다. */
  mapping: Mapping;
  /** 칸 안의 목록은 경로 이름을 줄여 적는다. 자리가 이미 어느 칸인지 말한다. */
  showPath?: boolean;
  onEditIssue?: (issue: MappingIssue) => void;
};

/** 검증 issue 목록. 문장은 코드로 고르고 BE 원문은 `기술 정보` 에 접는다(규칙 §5). */
export function IssueList({
  issues,
  label,
  mapping,
  showPath = true,
  onEditIssue,
}: IssueListProps) {
  if (issues.length === 0) {
    return null;
  }
  return (
    <ul className={styles.issues} aria-label={label}>
      {issues.map((issue, index) => (
        <li
          // issue 에는 고유 식별자가 없다. 목록은 결과가 올 때마다 통째로 바뀐다.
          key={`${issue.code}:${issue.path}:${index}`}
          className={issue.severity === "error" ? styles.issueError : styles.issueWarning}
        >
          <span className={styles.issueSeverity}>
            {issue.severity === "error" ? "오류" : "경고"}
          </span>
          {showPath ? `${describeMappingPath(mapping, issue.path)}: ` : null}
          {mappingIssueText(issue)}
          {onEditIssue === undefined || issueTarget(issue.path, mapping) === null ? null : (
            <IconButton
              text={`${describeMappingPath(mapping, issue.path)} 수정`}
              size="sm"
              variant="surface"
              onClick={() => onEditIssue(issue)}
            />
          )}
          <details>
            <summary>기술 정보</summary>
            <pre>{mappingIssueDetails(issue).join("\n")}</pre>
          </details>
        </li>
      ))}
    </ul>
  );
}
